// extracted by mini-css-extract-plugin
module.exports = {"disabledCheckbox":"Probation_disabledCheckbox__bHMjP","disabledLabel":"Probation_disabledLabel__xGbpY"};